import { expressionFunction } from "vega";
import { formatNumber, NUMBER_FORMAT_TYPE } from "../specs/format.js";

let registered = false;

/**
 * Registers the expression functions the spec builders' specs call — today
 * the number formatter behind `NumberFormat` (`vizNumber(value, options)`).
 * Vega keeps one global table of them, read by the expression interpreter as
 * well, so once is enough. Charts register on import; a headless renderer
 * calls this before parsing.
 */
export function registerVizExpressions(): void {
  if (registered) return;
  registered = true;
  expressionFunction(NUMBER_FORMAT_TYPE, (value: unknown, format: unknown) =>
    formatNumber(
      value,
      typeof format === "object" && format !== null
        ? (format as Intl.NumberFormatOptions)
        : undefined,
    ),
  );
}
